import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const API_URL = (process.env.REACT_APP_API_URL || '').trim().replace(/\/$/, '');

export default function CatalogLandingPage() {
  const { workspaceId, catalogSlug } = useParams();

  useEffect(() => {
    const apiEndpoint = `${API_URL}/catalog/landing-page/${encodeURIComponent(workspaceId)}/${encodeURIComponent(catalogSlug)}`;

    fetch(apiEndpoint, { cache: 'no-store' })
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.text();
      })
      .then((html) => {
        const baseTag = `<base href="${API_URL}/">`;
        const apiBaseScript = `<script>window.__EAGLE_API_BASE__ = ${JSON.stringify(API_URL)};</script>`;

        const injected = html
          .replace(/(<head[^>]*>)/i, `$1${baseTag}${apiBaseScript}`);

        document.open();
        document.write(injected);
        document.close();
      })
      .catch(() => {
        document.open();
        document.write('<p style="font-family:sans-serif;padding:2rem">Catálogo não encontrado.</p>');
        document.close();
      });
  }, [workspaceId, catalogSlug]);

  return null;
}
